// Browser SpeechSynthesis helper — speaks with a natural male English voice when available.
// Used as a fallback when server-side OpenAI TTS (onyx) is unavailable (e.g. proactive alerts
// that should fire without hitting the LLM endpoint).

const MALE_HINTS = [
    "david", "daniel", "oliver", "mark", "james", "aaron", "fred",
    "google uk english male", "microsoft david", "microsoft mark", "microsoft james",
    "rishi", "arthur", "matthew", "brian",
];

let _cachedVoice = null;

function pickMaleVoice() {
    if (_cachedVoice) return _cachedVoice;
    if (!window.speechSynthesis) return null;
    const voices = window.speechSynthesis.getVoices() || [];
    if (voices.length === 0) return null;

    const en = voices.filter((v) => (v.lang || "").toLowerCase().startsWith("en"));
    // 1) Exact / substring match on known male voices
    for (const hint of MALE_HINTS) {
        const match = en.find((v) => (v.name || "").toLowerCase().includes(hint));
        if (match) { _cachedVoice = match; return match; }
    }
    // 2) Any voice whose name contains 'male' but not 'female'
    const byName = en.find((v) => {
        const n = (v.name || "").toLowerCase();
        return n.includes("male") && !n.includes("female");
    });
    if (byName) { _cachedVoice = byName; return byName; }
    // 3) Fallback to first English voice
    _cachedVoice = en[0] || voices[0] || null;
    return _cachedVoice;
}

export function speakNatural(text, { rate = 0.97, pitch = 0.92 } = {}) {
    if (!text || !window.speechSynthesis) return;
    try {
        window.speechSynthesis.cancel();
        const utter = new SpeechSynthesisUtterance(text);
        utter.rate = rate;     // slightly slower for clarity
        utter.pitch = pitch;   // slightly lower pitch → more masculine even on neutral voices
        const v = pickMaleVoice();
        if (v) utter.voice = v;
        window.speechSynthesis.speak(utter);
    } catch { /* ignore */ }
}

// Some browsers populate voice list asynchronously — refresh cache on the onvoiceschanged event.
if (typeof window !== "undefined" && window.speechSynthesis) {
    try {
        window.speechSynthesis.onvoiceschanged = () => { _cachedVoice = null; };
    } catch { /* ignore */ }
}
